import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SettingsProvider } from "@/lib/SettingsContext";
import { Toaster } from "@/components/ui/sonner";
import { LandingPage } from "@/pages/LandingPage";
import { PolicyPage } from "@/pages/PolicyPage";

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PolicyPage type="privacy" />} />
          <Route path="/terms" element={<PolicyPage type="terms" />} />
          <Route path="/bylaws" element={<PolicyPage type="bylaws" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </SettingsProvider>
  );
}

export default App;
